import React, { useState } from 'react';

import { useLocation } from 'react-router-dom';

import Container from '@src/components/commons/containerPage.common';
import LabTabs from '@src/components/commons/tabs.common';

import ClinicAnalytic from './clinicAnalytics';
import ClinicBranchList from './tableClinicList';

export default function ClinicBranchPage() {
  const path = useLocation().pathname;
  const [selectedIdx, setSelectedIdx] = useState(0);

  const categories = [
    {
      idx: 0,
      title: 'Clinic Branch',
      component: <ClinicBranchList />,
    },
    {
      idx: 1,
      title: 'App Overview',
      component: <ClinicAnalytic />,
    },
  ];

  return (
    <Container pathUrl={path}>
      <div className='px-2 py-8'>
        <LabTabs
          menus={categories}
          selectedIdx={selectedIdx}
          onChange={setSelectedIdx}
        />
      </div>
    </Container>
  );
}
